'use strict';

angular.module('shiftTraderApp')
  .directive('saIntelliViewShift', function (saViewShiftRowHeightInt, saViewShiftHourWidthInt,
                                             saIntelliViewShiftDropdownWidthInPx,
                                             saIntelliViewShiftPublishedWidthInPx,
                                             zIndexManageWorkPeriodsMax, Notes, NotesOverlayContextService,
                                             $compile, $rootScope, $timeout, $filter, $q,
                                             TimeService, PositioningService, AvailabilitySets, AvailabilityRules,
                                             WorkPeriodStore, MWPHighlightService, NotesStore, EventStreamsService) {

      var dynamicLayoutThreshold = 180; // number of pixels that the shift must be less than or equal to in order to make dynamic layout occur.

      var numberFilter = $filter('number');

      var publishedIconHTML = '<div class="intelli_view_shift_publish_icon">℗</div>';
      var publishedIconHTMLWidth = 17;
      var shiftUserTemplate = '<div class="intelli_view_shift_user">{nameString}</div>';
      var userInitialsWidth = 22;
      var shiftAddUserTemplate = '<div class="intelli_view_shift_add_user">' +
          '<a href="" class="sa_link sa_white sa_lighttheme" data-ng-click="editShift()">' +
            '<div class="intelli_view_shift_add_user_circle_wrapper">' +
              '<div class="intelli_view_shift_add_user_circle"></div>' +
              '<div class="intelli_view_shift_add_user_icon"><i class="icon-plus-sign"></i></div>' +
            '</div>' +
          '{label}</a>' +
          '</div>';
      var shiftAddUserTemplateAddition = '<div class="intelli_view_shift_add_user_text">Assign</div>';
      var shiftAddUserTemplateWidth = 21;
      var shiftAddUserTemplateWithAdditionWidth = 64;

      var shiftTimeTemplate = '<div class="intelli_view_shift_time">{theTime}</div>';

      var fromLastViewTemplate = '<div class="intelli_view_shift_from_prev_view"><i class="icon-arrow-left"></i></div>';
      var intoNextViewTemplate = '<div class="intelli_view_shift_into_next_view"><i class="icon-arrow-right"></i></div>';
      var fromIntoViewTemplateWidth = 13;

      var dropdownShiftUserTemplate = '<li>' +
        '<div style="padding: 1px 10px;" class="intelli_view_shift_dd_name darkgray_text">' +
          '<a href="#/profile/{{::obj.user.id}}" target="_blank"><span ng-bind="::obj.user.name | abbreviatedName"></span></a>' +
          '<div class="training_indicator_circle training_indicator_view_shift_dd_placement" ng-if="::obj.training">' +
            '<span class="training_indicator_circle_inner">TR</span>' +
          '</div>' +
        '</div>' +
      '</li>';

      var dropdownShiftTimeTemplate = '<li>' +
          '<div style="padding: 1px 10px;" class="darkgray_text">' +
            '<div class="intelli_view_shift_publish_icon" style="padding-left:0px;" ng-if="::obj.$isPublished()">℗</div>' +
            '<span ng-bind="::obj._shortLocalStartTime"></span> - <span ng-bind="::obj._shortLocalEndTime"></span>' +
          '</div>' +
        '</li>';

      var dropdownShiftCostTemplate = '<li>' +
          '<div style="padding: 1px 10px;" class="darkgray_text">' +
          'Cost: <span ng-bind="::obj._shiftCost | currency"></span>' +
          '</div>' +
        '</li>';

      var dropdownShiftCostEstimateTemplate = '<li>' +
          '<div style="padding: 1px 10px;" class="darkgray_text">' +
          'Est Cost: <span ng-bind="::obj._shiftEstimate | currency"></span>' +
          '</div>' +
        '</li>';

      var dropdownAssignEmpTemplate = '<li>' +
          '<a href="" data-ng-click="editShift()">' +
            '<i class="icon-plus-sign" style="margin-right: 4px;"></i>Assign Employee' +
          '</a>' +
          '</li>';

      var dropdownEditTemplate = '<li>' +
          '<a href="" data-ng-click="editShift()">' +
            '<i class="icon-pencil" style="margin-right: 4px;"></i>Edit Shift' +
          '</a>' +
        '</li>';

      var dropdownSplitTemplate = '<li>' +
        '<a href="" data-ng-click="splitShift()">' +
        '<i class="icon-unlink rotate_-45deg" style="margin-right: 4px;"></i>Split Shift' +
        '</a>' +
        '</li>';

      var dropdownPublishTemplate = '<li>' +
          '<a href="" data-ng-click="publishShift()" confirm="Are you sure you want to publish this shift?">' +
            '<div style="margin-right:7px;font-size:1.4em;display:inline-block;margin-top:-2px;">' +
              '℗' +
            '</div>' +
            '<div style="display:inline-block">' +
              'Publish Shift' +
            '</div>' +
          '</a>' +
        '</li>';

      var dropdownDuplicateTemplate = '<li>' +
          '<a href="" data-ng-click="duplicateShift()">' +
            '<i class="icon-copy" style="margin-right: 4px;"></i>Duplicate Shift' +
          '</a>' +
        '</li>';

      var dropdownRemoveTemplate = '<li>' +
            '<a href="" data-ng-click="inactivateShift()">' +
              '<i class="icon-remove" style="margin-right: 3px;"></i>Remove Shift' +
            '</a>' +
          '</li>';

      var dropdownCreateNoteTemplate = '<li>' +
          '<a sa-feature-required="notes" href="" ng-click="createNote()">' +
            '<i class="sa-icon-notes" style="margin-right: 3px;"></i>Create Note' +
          '</a>' +
        '</li>';

      var dropdownViewNotesTemplate = '<li>' +
          '<a sa-feature-required="notes" href="" ng-click="viewNotes()">' +
            '<i class="sa-icon-notes" style="margin-right: 3px;"></i>View Notes' +
          '</a>' +
        '</li>';

      var genDropdownShiftTimeTemplate = function(content) {
        var html = '<li class="mwp_styled_times dropdown_shift_time">';
        html += content;
        html += '</li>';
        return html;
      };

      var genEditableContainerTemplate = function(isShift, widthInHours, isEditing, timeHasChanged) {
        var html = '';
        html += '<div class="central_label">';
        if (!isShift) {
          html += '<div class="save_edit base_edit_btn" data-ng-click="saveEdits()">Save</div>';
          html += '<div class="cancel_edit base_edit_btn" data-ng-click="cancelEdits()">Cancel</div>';
        } else {
          if (widthInHours >= 2.5) {
            html += '<div class="shift_time_container">{theEditTime}</div>';
          }

          if (widthInHours >= 3.75) {
            if (timeHasChanged) {
              html += '<div class="revert_edit base_edit_btn" data-ng-click="cancelEdits()">Revert</div>';
            }

            html += '<div class="dismiss_edit base_edit_btn" data-ng-click="dismissShift()">Dismiss</div>';
          }
        }
        html += '</div>';

        if (isEditing) {
          html += '<div class="left_handle drag_handle"><i class="trim_shift_icon"><i></i><i></i><i></i></i></div>';
          html += '<div class="right_handle drag_handle"><i class="trim_shift_icon"><i></i><i></i><i></i></i></div>';
        }

        return html;
      };

      var genHoverContainerTemplate = function(isShift, widthInHours, isDismissed) {
        var html = '';

        var btnWidthRequirementInHours = 1.25;
        var timeWidthRequirementInHours = 2.5;

        if (widthInHours >= btnWidthRequirementInHours && !isDismissed) {
          html += '<div class="start_edit base_edit_btn" data-ng-click="toggleEditable()">Edit</div>'
        }

        if (widthInHours >= 1.5 && isShift && isDismissed && html === '') {
          html += '<div class="undismiss_edit base_edit_btn" data-ng-click="undismissShift()">Undismiss</div>';
        }

        if (html !== '' && widthInHours >= (btnWidthRequirementInHours + timeWidthRequirementInHours)) {
          html += '<div class="shift_time_container">{theEditTime}</div>';
        }
        return html;
      };


      var getHiddenDimensions = function(elem, outer) {
        var $this = $(elem);
        if ($this.length == 0) {
          return false;
        }
        var $clone = $this.clone()
            .show()
            .css({
              visibility: 'hidden'
            })
            .appendTo('.sa_intelli_view_test_container');

        var result = {
          width:      ((outer) ? $clone.outerWidth() : $clone.innerWidth()) + 1
        };
        $clone.remove();
        return result;
      };

      var getObjTwixWithRespectToViewWindow = function(objTwix, viewWindow) {
        // check to see if theTwix is over the current viewWindow, modify if necessary
        if (objTwix.start.isBefore(viewWindow.start)) {
          // theTwix starts before the current viewWindow
          objTwix = moment(viewWindow.start).twix(objTwix.end.clone());
        } else if (objTwix.end.isAfter(viewWindow.end)) {
          objTwix = moment(objTwix.start).twix(viewWindow.end.clone());
        }
        return objTwix;
      };

      var generateOptimalContent = function(maxWidth, contentObjects) {
        var availWidth = lodash.clone(maxWidth);
        var prioritySortedContentObjects = lodash.sortBy(contentObjects, 'priority'); // ASC sort
        var optIdx;
        var currIndices = [];
        var temp;
        var numPixelsNeeded;

        lodash.forEach(prioritySortedContentObjects, function(obj) {
          obj.contentOptions = lodash.sortBy(obj.contentOptions, 'width'); //smallest content options first
        });

        //console.log('prioritySortedContentObjects', maxWidth, prioritySortedContentObjects);

        lodash.forEach(prioritySortedContentObjects, function(obj, idx) {
          // check if obj fits with any of it's options, starting with largest contentOption
          optIdx = lodash.findLastIndex(obj.contentOptions, function(opt) { // want to try out the largest options first
              return opt.width <= availWidth;
            });
          if (optIdx > -1) {
            currIndices.push(optIdx); // contentOption index being used
            availWidth -= obj.contentOptions[optIdx].width;
          } else {
            // how many pixels do we need for everything to work?
            numPixelsNeeded = obj.contentOptions[0].width - availWidth + 1; // just ask for an extra pixel :-)
            //console.log('obj', obj.contentName, ' @ index ', idx, ' doesnt fit. Need ', numPixelsNeeded, 'pixels');
            //console.log('needs ', obj.contentOptions[0].width, ' only has: ', availWidth);
            // let's try to optimize contentOption widths of objects before us
            //console.log('currentIndices:', currIndices);
            temp = optimizeContentOptionsWidths(prioritySortedContentObjects, idx, currIndices, numPixelsNeeded);
            //console.log('optimizeContentOptionsWidths result: ', temp);
            if (temp) {
              currIndices = lodash.clone(temp); // the new optimized contentOptionsIndices
              currIndices.push(0); // we're going to use the smallest contentOptions in this contentObject

              //calculate the new available width based on any optimizations
              availWidth = maxWidth - lodash(currIndices).map(function(oi, i) {
                if (oi > -1) {
                  return prioritySortedContentObjects[i].contentOptions[oi].width;
                } else {
                  return 0;
                }
              }).reduce(function(sum, num) {
                return sum + num;
              }, 0);
              //console.log('availWidth after optimization:', availWidth);
            } else {
              currIndices.push(-1);
            }
          }
        });

        // now go retrieve the content and sort it by displayOrder
        var obj;
        return lodash(currIndices).map(function(contentOptIdx, contentObjIdx) {
//          console.log(contentObjIdx, contentOptIdx);
          if (contentOptIdx > -1) {
            obj = prioritySortedContentObjects[contentObjIdx];
//            console.log(obj);
            return {
              name: obj.contentName,
              displayOrder: obj.displayOrder,
              content: obj.contentOptions[contentOptIdx]
            };
          } else {
            return undefined;
          }
        }).reject(lodash.isUndefined).sortBy('displayOrder').map('content').value();
      };

      var optimizeContentOptionsWidths = function(objects, currentIdx, currIndices, numPixelsNeeded) {
//        console.log('optimizeContentOptionsWidth:', currentIdx, numPixelsNeeded);
//        console.log(currIndices);
        var optIdx;
        var newIndices = lodash.clone(currIndices);
        var numPixelsFound = 0;
        var returnValue = false;

        if (currentIdx === 0) {
          return false;
        }

        // first loop over here is to try a change in each object one at a time to get the numPixelsNeeded

        // only loop over objects up to currentIdx. Also, start with the highest priority value first
        lodash.eachRight(objects.slice(0, currentIdx), function(obj, idx) {
          if (newIndices[idx] > 0) {
            // look through the contentOptions and try to find something that gives us >= numPixelsNeeded
            lodash.eachRight(obj.contentOptions, function(opt, idy) {
//              console.log(opt.width, obj.contentOptions[newIndices[idx]].width, newIndices[idx]);
              if ((obj.contentOptions[newIndices[idx]].width - opt.width) >= numPixelsNeeded) {
//                console.log('idy', idy);
                optIdx = lodash.clone(idy);
                numPixelsFound = obj.contentOptions[newIndices[idx]].width - opt.width;
                return false; // exit eachRight
              }
            });
          }

          if (numPixelsFound >= numPixelsNeeded) {
//            console.log('numPixelsfound >= numPixelsNeeded');
//            console.log('optIdx', optIdx);
            newIndices[idx] = optIdx;
            returnValue = newIndices;
            return false; // exit eachRight
          }

        });

        return returnValue;
      };

      return {
      templateUrl: 'views/directives/saIntelliViewShift.html',
      restrict: 'A',
      require: ['^saWideWorkPeriodView', '^saPositionBar'],
      link: function postLink(scope, element, attrs, ctrls) {
        // window.logTime('saIntelliViewShift init ' + scope.obj.id);
        var stream = EventStreamsService.getStream(EventStreamsService.names.mwpUpdates);
        var disposableSubscriptions = [];

        scope.workPeriodViewCtrl = ctrls[0];
        var saPositionBarCtrl = ctrls[1];

        scope.state = {
          rawPermissions: null,
          derivedPermissions: null,
          notes: null
        };

        function processRawPermissions() {
          var isPublished = scope.obj.$isPublished();

          scope.state.derivedPermissions = {
            canPublish: !isPublished && scope.state.rawPermissions['work_periods.publish'],
            canSplit: !isPublished && scope.state.rawPermissions['work_periods.update'] || isPublished && scope.state.rawPermissions['work_periods.split_published'],
            canSetInactive: !isPublished && scope.state.rawPermissions['work_periods.set_unpublished_inactive'] || isPublished && scope.state.rawPermissions['work_periods.set_published_inactive'],
            canCreate: scope.state.rawPermissions['work_periods.create'],
            canUpdate: !isPublished && scope.state.rawPermissions['work_periods.update'] || isPublished && scope.state.rawPermissions['work_periods.change_published'],
            canDuplicate: scope.state.rawPermissions['work_periods.create'],
            canViewActualPayRate: scope.state.rawPermissions['users.view_actual_employee_wages'],
            canViewEstimatedPayRate: scope.state.rawPermissions['users.view_estimated_labor_cost']
          };

          if (scope.obj.id) {
            // unsure if we will always have scope.obj.id defined when this is called -- Matt
            NotesStore.getNotesForObjWithDate('WorkPeriod', scope.obj.id, scope.obj.range_twix)
              .then(function(notesForObj) {
                scope.state.notes = notesForObj;
                var myPermLevel = (scope.state.rawPermissions['notes.view_public']) ? 0 : -1;
                myPermLevel = (scope.state.rawPermissions['notes.view_management']) ? 1 : myPermLevel;
                myPermLevel = (scope.state.rawPermissions['notes.view_admin']) ? 2 : myPermLevel;

                scope.state.derivedPermissions = lodash.extend(scope.state.derivedPermissions, {
                  canCreateNote: scope.state.rawPermissions['notes.create'] && scope.state.notes.length === 0,
                  canViewNotes: lodash.some(scope.state.notes, function(note) {
                    return note.permission <= myPermLevel;
                  })
                });
              }, function() {

              });

          }
        }

        // get rawPermissions from manageWorkPeriodsCtrl
        $q.all([scope.workPeriodViewCtrl.getRawPermissions(), Notes.getGeneralPermissions(scope.workPeriodViewCtrl.getOrg().id)])
          .then(function(results) {
            scope.state.rawPermissions = lodash.extend(results[0], results[1]);
            processRawPermissions();
          });

        scope.showEditUI = false;

        var dynamicContentContainer = $(element).find('.dynamically_drawn_content');
        var contentContainer = $(element).find('.content_container');

        var hiddenDimensionsCache = {};

        var clearHiddenDimensionsCache = function() {
          hiddenDimensionsCache = {};
        };

        // zero some properties that we tend to reuse
        scope.obj._dismissed = undefined;
        scope.obj.editingTwix = undefined;

        var currentDate;
        var viewWindow;
        var positioningResults;
        var hourOffsetFromLeft = 6.0;
        var hourExtensionToRight = 6.0;
        var containerWidthInPx;
        var remainingWidthInPx;
        var dropdownElem = $(element).find('.uib-dropdown-menu');

        var hasTimeBeenEdited = function() {
          return scope.obj.editingTwix && !scope.obj.editingTwix.equals(scope.obj.range_twix)
        };

        var getViewWidthInPx = function() {
          return viewWindow.length('hours') * saViewShiftHourWidthInt;
        };

        var calcZIndex = function() {
          return saPositionBarCtrl.getPositionZIndexStart() -
              scope.obj._expandedTop/saViewShiftRowHeightInt - 1;
        };

        var positionDropdown = function() {
          var viewWidthInPx = getViewWidthInPx();
          var shiftLeftPosInPx = viewWidthInPx * scope.workPeriodStyle.left.slice(0,-1) / 100.0;
          var shiftWidthPosInPx = viewWidthInPx * scope.workPeriodStyle.width.slice(0,-1) / 100.0;
          var dropdownLeftPos = getHiddenDimensions(dropdownElem, true).width * -1;
//          console.log('dropdownLeftPos', dropdownLeftPos);

          // the case where the dropdown would hang to the left side of the view
          if ( (shiftLeftPosInPx + shiftWidthPosInPx) < (dropdownLeftPos * -1 + 10)) {
            dropdownElem.css('left', -1 * shiftWidthPosInPx + 10);
          } else if ((shiftLeftPosInPx + shiftWidthPosInPx) >= viewWidthInPx) {
            dropdownElem.css('left', dropdownLeftPos - 15);
          } else {
            dropdownElem.css('left', dropdownLeftPos);
          }
        };

        var buildDropdownMenuItems = function() {
          var genShiftLengthCode = function(twx) {
            return '<div class="length_area"><span>' + numberFilter(twx.length('minutes') / 60.0, 1) + '</span><span>hrs</span></div>'
          };

          var elemsToAdd = [];

          if (scope.obj.$isWorkPeriod()) {
            elemsToAdd.push({
              displayOrder: 1,
              rawContent: dropdownShiftTimeTemplate
            });

            if (scope.obj.$isAssigned()) {
              elemsToAdd.push({
                displayOrder: 0,
                rawContent: dropdownShiftUserTemplate
              });

              if (!scope.inThePast && scope.state.derivedPermissions.canUpdate) {
                elemsToAdd.push({
                  displayOrder: 15,
                  rawContent: dropdownEditTemplate
                });
              }

              if (!scope.inThePast && !scope.obj.$isPublished() && scope.state.derivedPermissions.canPublish) {
                elemsToAdd.push({
                  displayOrder: 20,
                  rawContent: dropdownPublishTemplate
                });
              }
            } else {
              //workPeriod is unassigned (.user is null)
              if (!scope.inThePast && !scope.obj.$isPublished() && scope.state.derivedPermissions.canUpdate) {
                elemsToAdd.push({
                  displayOrder: 0,
                  rawContent: dropdownAssignEmpTemplate
                });
              }
            }

            if (!scope.inThePast && scope.state.derivedPermissions.canSplit) {
              elemsToAdd.push({
                displayOrder: 21,
                rawContent: dropdownSplitTemplate
              })
            }

            if (scope.state.derivedPermissions.canViewActualPayRate) {
              elemsToAdd.push({
                displayOrder: 10,
                rawContent: dropdownShiftCostTemplate
              });
            } else if (scope.state.derivedPermissions.canViewEstimatedPayRate) {
              elemsToAdd.push({
                displayOrder: 10,
                rawContent: dropdownShiftCostEstimateTemplate
              })
            }


            if (scope.state.derivedPermissions.canDuplicate) {
              elemsToAdd.push({
                displayOrder: 100,
                rawContent: dropdownDuplicateTemplate
              });
            }

            if (scope.state.derivedPermissions.canSetInactive) {
              elemsToAdd.push({
                displayOrder: 101,
                rawContent: dropdownRemoveTemplate
              });
            }

            if (scope.state.derivedPermissions.canCreateNote) {
              elemsToAdd.push({
                displayOrder: 17,
                rawContent: dropdownCreateNoteTemplate
              });
            }

            if (scope.state.derivedPermissions.canViewNotes) {
              elemsToAdd.push({
                displayOrder: 17,
                rawContent: dropdownViewNotesTemplate
              });
            }

          } else {
            // This is a Shift Dropdown (not workPeriod)

            var theTwix = scope.obj.editingTwix ? scope.obj.editingTwix : scope.obj.range_twix;

            elemsToAdd.push({
              displayOrder: 0,
              rawContent: genDropdownShiftTimeTemplate(TimeService.minimalTwixFormat(theTwix, true, true) + genShiftLengthCode(theTwix))
            });

            if (scope.obj._dismissed) {
              elemsToAdd.push({
                displayOrder: 15,
                rawContent: '<li><a href="" data-ng-click="undismissShift()">Undismiss</a></li>'
              });
            } else {
              elemsToAdd.push({
                displayOrder: 15,
                rawContent: '<li><a href="" data-ng-click="dismissShift()">Dismiss</a></li>'
              });

              if (!scope.showEditUI && scope.state.derivedPermissions.canCreate) {
                elemsToAdd.push({
                  displayOrder: 12,
                  rawContent: '<li><a href="" data-ng-click="toggleEditable()">Edit</a></li>'
                });
              }
            }

            if (hasTimeBeenEdited()) {
              elemsToAdd.push({
                displayOrder: 10,
                rawContent: genDropdownShiftTimeTemplate('<div class="dropdown_shift_time_label">Orig:</div>' + TimeService.minimalTwixFormat(scope.obj.range_twix, true, true) + genShiftLengthCode(scope.obj.range_twix))
              });

              elemsToAdd.push({
                displayOrder: 20,
                rawContent: '<li><a href="" data-ng-click="cancelEdits()">Revert</a></li>'
              });
            }
          }

          dropdownElem.empty();
          dropdownElem.append($compile(lodash(elemsToAdd).sortBy('displayOrder').map('rawContent').value().join(' '))(scope));
        };

        var drawContents = function() {
          //window.logTime('drawContents start ' + scope.obj.id);
          var testDim, testElem;
          var contentObjects = [];
          var temp, contentOptTemp;

          element.attr('id', (scope.obj.$isWorkPeriod() ? 'wp-' : 'shift-') + scope.obj.id);

          // apply the new styles and classes w/o angular (eliminates a ton of watches)
          element.attr('class', lodash(scope.wpClasses).pickBy(function(x) {return x;}).keys().join(' '));
          element.css(scope.workPeriodStyle);

          containerWidthInPx = getViewWidthInPx() * scope.workPeriodStyle.width.slice(0,-1) / 100.0;
//          console.log('containerWidthInPx @ ', (scope.obj.range_twix.length('minutes') / 60.0).toFixed(2), 'hours: ', containerWidthInPx.toFixed(2));

          if (containerWidthInPx <= dynamicLayoutThreshold) { // if less than dynamicLayoutThreshold in width then do dynamic
            remainingWidthInPx = lodash.clone(containerWidthInPx);

            if (scope.obj.$isWorkPeriod()) {
              remainingWidthInPx -= saIntelliViewShiftDropdownWidthInPx; // subtract width of the dropdown arrow, which has to be present all of the time

              if (scope.obj.$isPublished()) {
                temp = {
                  priority: -1,
                  displayOrder: 1,
                  contentName: 'publishIcon',
                  contentOptions: [
                    {
                      width: publishedIconHTMLWidth,
                      elem: publishedIconHTML
                    }
                  ]
                };
                contentObjects.push(temp);
              }

              if (scope.obj.$isAssigned()) {
                // let's test our ability to use First L.
                if (lodash.has(hiddenDimensionsCache, 'shiftUserTemplateFull')) {
                  contentOptTemp = hiddenDimensionsCache.shiftUserTemplateFull;
                } else {
                  testElem = shiftUserTemplate.replace('{nameString}', scope.obj.user.first_name + ' ' + scope.obj.user.last_name[0].toUpperCase() + '.');
                  testDim = getHiddenDimensions(testElem, true);
                  contentOptTemp = {
                    width: testDim.width,
                    elem: testElem
                  };
                  hiddenDimensionsCache.shiftUserTemplateFull = lodash.clone(contentOptTemp);
                }

                temp = {
                  priority: 1,
                  displayOrder: 10,
                  contentName: 'userName',
                  contentOptions: [
                    contentOptTemp
                  ]
                };

                //now the straight-up initials option
                testElem = shiftUserTemplate.replace('{nameString}', scope.obj.user.first_name[0].toUpperCase() + scope.obj.user.last_name[0].toUpperCase());
                temp.contentOptions.push({
                  width: userInitialsWidth,
                  elem: testElem
                });

                contentObjects.push(temp);
              } else {
                // it's an unassigned workPeriod

                // if this is an unassigned workPeriod and it's not in the past then put the assign button on it
                testElem = $compile(shiftAddUserTemplate.replace('{label}', shiftAddUserTemplateAddition))(scope);
                if (!scope.obj.$isAssigned() && !scope.inThePast) {
                  temp = {
                    priority: 1,
                    displayOrder: 10,
                    contentName: 'assignUser',
                    contentOptions: [
                      {
                        width: shiftAddUserTemplateWithAdditionWidth,
                        elem: testElem
                      }
                    ]
                  };


                  // test it out with the additional label ("Assign")
                  testElem = $compile(shiftAddUserTemplate.replace('{label}',''))(scope);
                  temp.contentOptions.push({
                    width: shiftAddUserTemplateWidth,
                    elem: testElem
                  });
                  contentObjects.push(temp);
                }
              }

            } else {
              // it's a shift!
            }

            // now let's see if we can fit the time!

            if (lodash.has(hiddenDimensionsCache, 'shiftTimeTemplate')) {
              contentOptTemp = hiddenDimensionsCache.shiftTimeTemplate;
            } else {
              testElem = shiftTimeTemplate.replace('{theTime}', TimeService.minimalTwixFormat(scope.obj.range_twix, true, true));
              testDim = getHiddenDimensions(testElem, true);
              contentOptTemp = {
                width: testDim.width,
                elem: testElem
              };
              hiddenDimensionsCache.shiftTimeTemplate = lodash.clone(contentOptTemp);
            }


            temp = {
              priority: 1,
              displayOrder: 20,
              contentName: 'shiftTime',
              contentOptions: [
                contentOptTemp
              ]
            };

            contentObjects.push(temp);

            if (scope.fromLastView) {
              temp = {
                priority: -2,
                displayOrder: 0,
                contentName: 'fromLastView',
                contentOptions: [
                  {
                    width: fromIntoViewTemplateWidth,
                    elem: fromLastViewTemplate
                  }
                ]
              };

              contentObjects.push(temp);
            }

            if (scope.intoNextView) {
              temp = {
                priority: -2,
                displayOrder: 100,
                contentName: 'intoNextView',
                contentOptions: [
                  {
                    width: fromIntoViewTemplateWidth,
                    elem: intoNextViewTemplate
                  }
                ]
              };

              contentObjects.push(temp);
            }

            temp = generateOptimalContent(remainingWidthInPx, contentObjects);
          } else {


            // if our shift is greater than dynamicLayoutThreshold wide then do a dumb layout

            if (scope.obj.$isWorkPeriod()) {
              if (scope.obj.$isPublished()) {
                contentObjects.push({
                  displayOrder: 1,
                  contentName: 'publishIcon',
                  elem: publishedIconHTML
                });
              }

              if (scope.obj.$isAssigned()) {
                // let's test our ability to use First L.
                testElem = shiftUserTemplate.replace('{nameString}', scope.obj.user.first_name + ' ' + scope.obj.user.last_name[0].toUpperCase() + '.');
                contentObjects.push({
                  displayOrder: 10,
                  contentName: 'userName',
                  elem: testElem
                });
              } else {
                // it's an unassigned workPeriod

                // if this is an unassigned workPeriod and it's not in the past then put the assign button on it
                testElem = $compile(shiftAddUserTemplate.replace('{label}', shiftAddUserTemplateAddition))(scope);
                if (!scope.obj.$isAssigned() && !scope.inThePast) {
                  contentObjects.push({
                    displayOrder: 10,
                    contentName: 'assignUser',
                    elem: testElem
                  });
                }
              }

            } else {
              // it's a shift!
            }
            // now let's see if we can fit the time!
            testElem = shiftTimeTemplate.replace('{theTime}', TimeService.minimalTwixFormat(scope.obj.range_twix, true, true));
            contentObjects.push({
              displayOrder: 20,
              contentName: 'shiftTime',
              elem: testElem
            });

            if (scope.fromLastView) {
              contentObjects.push({
                displayOrder: 0,
                contentName: 'fromLastView',
                elem: fromLastViewTemplate
              });
            }

            if (scope.intoNextView) {
              contentObjects.push({
                displayOrder: 100,
                contentName: 'intoNextView',
                elem: intoNextViewTemplate
              });
            }
          }

          dynamicContentContainer.empty();

          if (containerWidthInPx <= dynamicLayoutThreshold) {
            dynamicContentContainer.append(lodash.map(temp, 'elem'));
          } else {
            dynamicContentContainer.append(lodash.map(lodash.sortBy(contentObjects, 'displayOrder'), 'elem'));
          }

          // if the arrow goes into the next view let's make sure it goes all the way to the right
          if (scope.intoNextView) {
            //after everything has been added let's stretch out the dynamic content container to be the width of content container minus the arrow width
            dynamicContentContainer.css('width', contentContainer.outerWidth() - saIntelliViewShiftDropdownWidthInPx); // -4px for right margin
          } else {
            dynamicContentContainer.css('width', 'auto');
          }

          //window.logTime('drawContents end ' + scope.obj.id);
        };

        var updateProperties = function(newDate) {
          // window.logTime('updateProperties START: ' + scope.obj.id);
          currentDate = newDate;
          scope.nowTime = TimeService.getNowInStoreTime();

          if (scope.obj.$isWorkPeriod()) {
            scope.obj._shortLocalStartTime = scope.obj.start_time.format('h:mm');
            scope.obj._shortLocalEndTime = scope.obj.end_time.format('h:mm');
            scope.inThePast = scope.obj.start_time.isBefore(scope.nowTime);
            scope.obj._shiftCost = scope.obj.range_twix.length('minutes') / 60.0 * scope.obj.hourly_wage;
            scope.obj._shiftEstimate = scope.obj.range_twix.length('minutes') / 60.0 * scope.workPeriodViewCtrl.getOrg().organization_config.hourly_rate_for_estimates
          } else {
            scope.obj.$setDateForTimeCalcs(currentDate);
            scope.obj._shortLocalStartTime = TimeService.minutesToTimeString(scope.obj.start_minutes, true);
            scope.obj._shortLocalEndTime = TimeService.minutesToTimeString(scope.obj.end_minutes, true);
          }

          element.removeClass('highlighted');

          viewWindow = moment(currentDate).subtract(hourOffsetFromLeft, 'hours').twix(moment(currentDate).add(24 + hourExtensionToRight, 'hours'));
          // TODO: turned this off because w/o changing the number of columns it makes the width incorrect
          //viewWindow.start.hours(18);
          //viewWindow.end.hours(6);
          //console.log('viewWindow2:', viewWindow.format());


          var activeTwix = scope.obj.editingTwix ? scope.obj.editingTwix : scope.obj.range_twix;
          positioningResults = PositioningService.calcLeftAndWidthInRatios(activeTwix, viewWindow);

          scope.intoNextView = positioningResults.intoNextView;
          scope.fromLastView = positioningResults.fromLastView;

          scope.wpClasses = {
            intelli_view_shift: true,
            clear_both: true,
            work_period: scope.obj.$isWorkPeriod(),
            shift: scope.obj.$isShift(),
            shift_animate_bg: scope.obj.$isShift(),
            published: scope.obj.$isPublished(),
            unpublished: !scope.obj.$isPublished(),
            assigned: scope.obj.$isAssigned(),
            unassigned: !scope.obj.$isAssigned(),
            came_from_selected_template: !!scope.obj._fromSelectedTemplate,
            not_from_selected_template: !!!scope.obj._fromSelectedTemplate,
            block_hover: positioningResults.diffInHours <= 1, // don't show the hover container (with edit btn) when shift is less than 1hr long
            hover: scope.obj.$isShift(), // automatically turn this on for shifts, exposing possible actions
            shorter_shift: positioningResults.diffInHours <= 1.5
          };

          //z-index trick is pretty neat here...
          //  In order for the dropdown menu to be on top of the next ship we must decrement
          //    the z-index for every wp/shift on the page
          //  scope.$index is the current index of the loop over wp/shifts in a position
          //  scope.$parent.$index is the current index of the loop over positions
          //  Max allows for 20 wp/shifts per position and up to 20? positions before we go behind the hour/half-hour lines

          scope.workPeriodStyle = {
            width: positioningResults.styles.width * 100 + '%',
            left: positioningResults.styles.left * 100 + '%',
            'z-index': calcZIndex(), // which row are we on
            top: scope.obj._expandedTop + 'px'
          };

          drawContents();
        };

        updateProperties(scope.workPeriodViewCtrl.getCurrentDate());

        scope.inactivateShift = function () {
          scope.$emit('inactivateShift', scope.obj.id);
        };

        scope.editShift = function() {
          scope.$emit('editShift', scope.obj);
        };

        scope.splitShift = function() {
          scope.$emit('splitShift', scope.obj);
        };

        scope.duplicateShift = function() {
          scope.$emit('duplicateShift', scope.obj);
        };

        scope.publishShift = function() {
          scope.$emit('publishSingleWorkPeriod', scope.obj);
        };

        scope.createNote = function() {
          // call the NotesOverlayContextService to create
          if (scope.obj.$isWorkPeriod()) {
            NotesOverlayContextService.setWorkPeriodContext(scope.obj);
            $rootScope.$broadcast('note-overlay-open', {action: 'expand-create'});
          }
        };

        scope.viewNotes = function() {
          // call the NotesOverlayContextService to view associated notes
          NotesOverlayContextService.setWorkPeriodContext(scope.obj);
          $rootScope.$broadcast('note-overlay-open');
        };

        scope.$on('mwpCurrentDateChange', function(event, newDate) {
          // window.logTime('mwpCurrentDateChange: ' + scope.obj.id);
          // event is emitted too often from saPositionBar, make sure that newDate !== currentDate
          if (!newDate.isSame(currentDate)) {
            //window.logTime('responded to mwpCurrentDateChange');
            var magnitude = currentDate.twix(newDate).length('hours') / 24.0;
            var direction = magnitude > 0 ? 1 : -1;
            var numDays = direction * Math.ceil(Math.abs(magnitude));
            var temp;
            var shouldUpdate = false;


            if (scope.obj.$isShift() && scope.obj.editingTwix) {
              temp = moment(scope.obj.editingTwix.start).add(numDays, 'days');
              temp = temp.twix(moment(scope.obj.editingTwix.end).add(numDays, 'days'));
              scope.obj.editingTwix = temp;
            }

            if (scope.obj.$isShift()) {
              shouldUpdate = true;
            } else {
              // make sure that shift is actually going to be in the viewWindow...
              var viewWindow = moment(newDate).subtract(hourOffsetFromLeft, 'hours').twix(moment(currentDate).add(24 + hourExtensionToRight, 'hours'));

              if (scope.obj.editingTwix ? scope.obj.editingTwix.overlaps(viewWindow) : scope.obj.range_twix.overlaps(viewWindow)) {
                shouldUpdate = true;
              }
            }

            if (shouldUpdate) {
              updateProperties(newDate);
              if (scope.obj.$isWorkPeriod() && scope.obj.$isAssigned()) {
                scope.getAvail();
              }

              // only update hours if this is a shift!
              if (scope.obj.$isShift()) {
                sentTemplateHoursUpdated();
              }
            }
          }
        });


        var lastTopInteger;
        var lastFromSelectedTemplate = false;
        var lastPublishedBy = null;
        disposableSubscriptions.push(stream.filterByType(['shiftTopUpdate', 'dataUpdate']).subscribe(function(update) {
          if (update.type === 'dataUpdate' && lastPublishedBy!== scope.obj.published_by) {
            if (scope.obj.$isWorkPeriod() && scope.obj.$isPublished()) {
              removeContentContainerHover();
            }

            updateProperties(currentDate);
            lastPublishedBy = scope.obj.published_by;
          }

          if (update.type === 'dataUpdate' && lastFromSelectedTemplate !== scope.obj._fromSelectedTemplate) {
            updateProperties(currentDate);
            lastFromSelectedTemplate = scope.obj._fromSelectedTemplate;
          }

          if (update.type === 'shiftTopUpdate' && lastTopInteger !== scope.obj._expandedTop) {
            setTopAndZIndex();
          }
        }));

        function setTopAndZIndex() {
          scope.workPeriodStyle['z-index'] = calcZIndex(); // which row are we on
          scope.workPeriodStyle.top = scope.obj._expandedTop + 'px';
          element.css(scope.workPeriodStyle);
          lastTopInteger = scope.obj._expandedTop;
        }

        setTopAndZIndex();

        var drawIntelliViewShiftEditable = function(theTwix, isShift, isEditing, timeHasChanged) {
          var lengthInHours = Math.abs(getObjTwixWithRespectToViewWindow(theTwix, viewWindow).length('minutes') / 60.0);

          var editableContainerTemplate = genEditableContainerTemplate(isShift, lengthInHours, isEditing, timeHasChanged);
          var editableContainerElem = $compile(editableContainerTemplate.replace('{theEditTime}', TimeService.minimalTwixFormat(theTwix, true, true)))(scope);
          element.find('.intelli_view_shift_editable').html(editableContainerElem);
        };

        var drawIntelliViewShiftHover = function(theTwix, isShift, isDismissed) {
          var lengthInHours = Math.abs(getObjTwixWithRespectToViewWindow(theTwix, viewWindow).length('minutes') / 60.0);
          var hoverContainerTemplate = genHoverContainerTemplate(isShift, lengthInHours, isDismissed);
          if (hoverContainerTemplate === '') {
            element.find('.intelli_view_shift_hover_container').addClass('no_width');
          } else {
            var hoverContainerElem = $compile(hoverContainerTemplate.replace('{theEditTime}', TimeService.minimalTwixFormat(theTwix, true, true)))(scope);
            element.find('.intelli_view_shift_hover_container').removeClass('no_width').html(hoverContainerElem);
          }
        };


        scope.toggleEditable = function() {
          //console.log('toggleEditable called');
          scope.showEditUI = !scope.showEditUI;
          if (scope.showEditUI) {
            if (!scope.obj.editingTwix) {
              scope.obj.editingTwix = moment(scope.obj.range_twix.start).twix(moment(scope.obj.range_twix.end));
            }
            updateTimeTooltips();

            element.addClass('editable');
            setupInteract();

            if (scope.obj.$isShift()) {
              scope.$emit('sa:manageWorkPeriod:editShiftStartedInit', scope.obj.id);
              element.addClass('editing');
              drawIntelliViewShiftEditable(scope.obj.editingTwix, true, true, hasTimeBeenEdited());
            }

            $timeout(function() {
              element.addClass('editable-active');
            }, 400);

          } else {
            var removeList = ['editable', 'editable-active'];
            if (!scope.obj.$isShift()) {
              removeList.push('hover');
            }

            lodash.forEach(removeList, function(cls) {
              element.removeClass(cls);
            });
            interact(element[0]).unset();
          }

          buildDropdownMenuItems();
          if (scope.obj.$isShift()) {
            sentTemplateHoursUpdated();
          }
        };

        var timeTooltips = {
          start: $(element).find('.intelli_view_shift_tether.start'),
          end: $(element).find('.intelli_view_shift_tether.end')
        };

        var updateTimeTooltips = function() {
          timeTooltips.start.html(TimeService.minimalMomentFormat(scope.obj.editingTwix.start, true, true));
          timeTooltips.end.html(TimeService.minimalMomentFormat(scope.obj.editingTwix.end, true, true));
        };

        var setupInteract = function() {
          interact(element[0])
            .resizable({
              edges: {left:'.left_handle.drag_handle', right: '.right_handle.drag_handle'},
              snap: {
                targets: [interact.createSnapGrid({x:10, y:0})],
                range: Infinity,
                elementOrigin: {x:0, y:0}
              },
              axis: 'x',
              autoScroll: true
            })
            .on('resizemove', function (event) {
              if (event.deltaRect.left !== 0 || event.deltaRect.right !== 0) {
                var startTimeIntervalDeltas = Math.round(event.deltaRect.left / 10);
                var endTimeIntervalDeltas = Math.round(event.deltaRect.right / 10);

                var tempTwix;
                if (lodash.isUndefined(scope.obj.editingTwix)) {
                  scope.obj.editingTwix = moment(scope.obj.range_twix.start).twix(scope.obj.range_twix.end);
                }

                //console.log(startTimeIntervalDeltas, endTimeIntervalDeltas);
                tempTwix = moment(scope.obj.editingTwix.start).add(15 * startTimeIntervalDeltas, 'minutes');
                tempTwix = tempTwix.twix(moment(scope.obj.editingTwix.end).add(15 * endTimeIntervalDeltas, 'minutes'));

                positioningResults = PositioningService.calcLeftAndWidthInRatios(tempTwix, viewWindow);

                element.css({
                  width: positioningResults.styles.width * 100 + '%',
                  left: positioningResults.styles.left * 100 + '%'
                });

                scope.obj.editingTwix = tempTwix;
                //console.log(scope.obj.editingTwix.format());
                updateTimeTooltips();

                if (scope.showingAvailability && scope.obj.$isWorkPeriod() && scope.obj.$isAssigned()) {
                  drawAvailabilityOverlay();
                }
                scope.$emit('sa:manageWorkPeriod:repositionViewShifts', {positionId: scope.obj.position_id});
                if (scope.obj.$isShift()) {
                  sentTemplateHoursUpdated();
                  drawIntelliViewShiftEditable(scope.obj.editingTwix, true, true, hasTimeBeenEdited());
                }
                buildDropdownMenuItems();
              }
            });

        };

        scope.renderDropdown = function() {
          // Goal here is to render & position dropdown on-demand, greatly increasing performance on full schedules

          // make sure to recalc Time and Name dimensions regardless of what happens next...
          // probably not really necessary, but a pretty good catch-all
          clearHiddenDimensionsCache();
          positionDropdown();
          buildDropdownMenuItems();
        };

        scope.dismissShift = function() {
          scope.obj._dismissed = true;
          element.addClass('dismissed');
          var theTwix = scope.obj.editingTwix ? scope.obj.editingTwix : scope.obj.range_twix;
          drawIntelliViewShiftHover(theTwix, true, scope.obj._dismissed);

          // only if we are currently showing the EditUI do we toggleEditable
          if (scope.showEditUI) {
            scope.toggleEditable();
          }
        };

        scope.undismissShift = function() {
          scope.obj._dismissed = undefined;
          element.removeClass('dismissed');
          var theTwix = scope.obj.editingTwix ? scope.obj.editingTwix : scope.obj.range_twix;
          drawIntelliViewShiftHover(theTwix, true, scope.obj._dismissed);
        };

        scope.cancelEdits = function() {
          //console.log('cancelEdits');
          scope.obj.editingTwix = undefined;
          scope.obj._dismissed = undefined;
          element.removeClass('dismissed');

          scope.toggleEditable();

          // make sure to recalc Time and Name dimensions
          clearHiddenDimensionsCache();
          updateProperties(currentDate);
          scope.$emit('redrawPositionBar', {positionId: scope.obj.position_id});
          if (scope.obj.$isWorkPeriod()) {
            if (scope.obj.$isAssigned()) {
              drawAvailabilityOverlay();
            }
          } else {
            drawIntelliViewShiftHover(scope.obj.range_twix, true, scope.obj._dismissed);
          }
        };

        scope.saveEdits = function() {
          //console.log('saveEdits');
          scope.obj.$update({
            start_time: scope.obj.editingTwix.start.utc().format(),
            end_time: scope.obj.editingTwix.end.utc().format()
          })
            .then(function(wp) {
              scope.obj.start_time = wp.start_time;
              scope.obj.end_time = wp.end_time;
              scope.obj.range_twix = wp.range_twix;

              scope.obj.editingTwix = undefined;

              // make sure to recalc Time and Name dimensions
              clearHiddenDimensionsCache();
              scope.toggleEditable();
              updateProperties(currentDate);

              WorkPeriodStore.replaceById(wp);
              scope.$emit('redrawPositionBar', {positionId: scope.obj.position_id});
              $rootScope.$broadcast('sa:manageWorkPeriod:WorkPeriodStoreUpdated', currentDate);

              // need to make sure to update the time in the hover area if it has changed
              drawIntelliViewShiftHover(scope.obj.range_twix, false, scope.obj._dismissed);

              if (wp.$isAssigned()) {
                drawAvailabilityOverlay();
              }
            });
        };


        if (scope.obj.$isWorkPeriod() && !scope.obj.$isPublished() && !scope.inThePast) {
          var hoverTimeout = null;
          contentContainer.hover(function(event) {
            var targetOk = true;
            if (!scope.obj.$isAssigned()) {
              targetOk = false;
              var addUser = element.find('.intelli_view_shift_add_user')[0];
            }
            hoverTimeout = $timeout(function() {
              if (event.target !== 'div.uib-dropdown-menu' && (targetOk || !$.contains(addUser, event.target)) && !scope.showEditUI) {
                element.addClass('hover');
              }
            }, 400);
          }, function(event) {
            if (hoverTimeout) {
              $timeout.cancel(hoverTimeout);
            }
            if (!scope.showEditUI) {
              //console.log('hoverout', event);
              element.removeClass('hover');
            }
          });

        } else if (scope.obj.$isShift()) {
          // add the hover class so that it acts like it's hovered for a "Shift" type
          element.addClass('hover');
        }

        var removeContentContainerHover = function() {
          contentContainer.unbind('mouseenter mouseleave');
        };

        var drawAvailabilityOverlay = function() {
          // look through time_off_rules for a day off here
          var timeOffOverlayBar = element.find('.intelli_view_shift_timeoff_overlay_bar');

          var conditions = {
            startDayOfWeek: scope.obj.range_twix.start.day(),
            twix: scope.obj.editingTwix ? scope.obj.editingTwix : scope.obj.range_twix
          };

          var theTwix = moment(conditions.twix.start).twix(moment(conditions.twix.end));
          theTwix = getObjTwixWithRespectToViewWindow(theTwix, viewWindow);
          var timesInBar = moment(theTwix.start).twix(theTwix.end.clone());
          var totalMinutes = Math.abs(theTwix.length('minutes'));

          var timeOffRules = lodash.filter(scope.user.time_off_rules, function(rule) {
            return rule.range_twix.overlaps(theTwix) && rule.active && rule.$isApproved();
          });

          if (timeOffRules.length > 0) {
            var timeOffUnion = lodash.reduce(lodash.map(timeOffRules, function(rule) {
              return rule.range_twix.intersection(theTwix);
            }), function(val, inter) {
              if (lodash.isNull(val)) {
                return inter;
              } else {
                return val.union(inter);
              }
            }, null);

            var startOffsetMin = theTwix.start.clone().twix(timeOffUnion.start).length('minutes');

            timeOffOverlayBar.css({
              left: startOffsetMin / totalMinutes * 100 + '%',
              width: timeOffUnion.length('minutes') / totalMinutes * 100 + '%'
            });
          } else {
            timeOffOverlayBar.css({
              left: 0,
              width: 0
            });
          }



          var relevantSet = lodash.find(scope.user.availability_sets, function(availSet) {
            return availSet.$isInEffect(scope.obj.range_twix.start) && availSet.$isApproved();
          });

          var daysOfWeekToAccept = [];

          if (relevantSet) {

            if(conditions.startDayOfWeek === 6) {
              daysOfWeekToAccept = [5,6,0];
            } else if (conditions.startDayOfWeek === 0) {
              daysOfWeekToAccept = [6,0,1];
            } else {
              daysOfWeekToAccept = [conditions.startDayOfWeek-1, conditions.startDayOfWeek, conditions.startDayOfWeek+1];
            }

            var availabilityToSearch = lodash.filter(relevantSet.availability_rules, function(ar) {
              return (lodash.includes(daysOfWeekToAccept, ar.day_of_week) || (ar._type === 'single')) && ar.active;
            });

            availabilityToSearch = lodash.map(availabilityToSearch, function(rule) {
              rule.$setStartEnd(conditions.twix.start);
              var newStart, newEnd, modRule;

              // adjust the week of the rules based on how close the rule's current start is to the day of interest

              // for when the rule is too far into the future
              if (moment(rule.start).isAfter(moment(conditions.twix.start).add(5, 'days'))) {
                //console.log('cond2', rule.id, 'initialTime: ', rule.range_twix.format());
                newStart = moment(rule.start).subtract(1, 'weeks');
                newEnd = moment(rule.end).subtract(1, 'weeks');
                modRule = moment(newStart).twix(newEnd);
              } else if (moment(rule.start).isBefore(moment(conditions.twix.start).subtract(5, 'days'))) {
                // for when the rule is too far into the past
                //console.log('cond1', rule.id, 'initialTime: ', rule.range_twix.format());
                newStart = moment(rule.start).add(1, 'weeks');
                newEnd = moment(rule.end).add(1, 'weeks');
                modRule = moment(newStart).twix(newEnd);
              } else {
                //console.log('cond3', rule.id, 'initialTime: ', rule.range_twix.format());
                modRule = rule.range_twix;
              }

              rule.start = modRule.start.clone();
              rule.end = modRule.end.clone();
              rule.range_twix = modRule;
              rule._startString = rule.start.format();
              rule._endString = rule.end.format();

              return rule;
            });

            availabilityToSearch = lodash.sortBy(availabilityToSearch, function(ar) {
              return ar.start.unix();
            });
            //console.log('in order:', availabilityToSearch);


            var sections = [];

            //console.log('WPID: ', scope.obj.id, '   theTwix:', theTwix.format());

            lodash.forEach(availabilityToSearch, function(rule, idx) {
              //console.log('WPID: ', scope.obj.id, '   RuleID: ', rule.id, '   IDX: ', idx, rule.range_twix.format());

              if (rule.range_twix.start.isAfter(theTwix.start) && rule.range_twix.start.isBefore(theTwix.end)) {
                sections.push({
                  idx: idx,
                  area: 1,
                  type: 'gray',
                  lengthInMinutes: Math.abs(moment(theTwix.start).twix(rule.range_twix.start.clone()).length('minutes'))
                });
                theTwix = moment(rule.range_twix.start).twix(moment(conditions.twix.end));
              } else if (rule.range_twix.start.isAfter(theTwix.start)) {
                var theEndpoint = rule.range_twix.start;
                if (rule.range_twix.start.isAfter(theTwix.end)) {
                  theEndpoint = theTwix.end.clone();
                }

                sections.push({
                  idx: idx,
                  area: 2,
                  type: 'gray',
                  lengthInMinutes: Math.abs(moment(theTwix.start).twix(theEndpoint.clone()).length('minutes'))
                });
                theTwix = moment(theEndpoint).twix(theTwix.end.clone());
              }

              if (theTwix.overlaps(rule.range_twix)) {
                var intersection = theTwix.intersection(rule.range_twix);
                sections.push({
                  idx: idx,
                  area: 3,
                  type: rule.avail ? 'green' : 'red',
                  lengthInMinutes: Math.abs(intersection.length('minutes'))
                });

                theTwix = intersection.end.twix(theTwix.end.clone());
              }

            });

            if (!theTwix.start.isSame(timesInBar.end)) {
              sections.push({
                idx: null,
                area: 4,
                type: 'gray',
                lengthInMinutes: Math.abs(theTwix.intersection(timesInBar).length('minutes'))
              })
            }

            //console.log(sections);

            // now let's figure out the DOM nodes to generate
            var leftPosition = 0;
            // use the where to filter out sections that put us at >100% total width
            var sectionStyling = lodash.filter(lodash.map(sections, function(sect) {
              // if we're at 100% then just exit, no need to render it.
              if (leftPosition >= 100) {
                return false;
              }

              var width = sect.lengthInMinutes / totalMinutes * 100;

              // if width would put us over 100% then truncate it to match 100% total
              if ((leftPosition + width) > 100) {
                width = 100 - leftPosition;
              }

              var ret = {
                styles: {
                  left: leftPosition + '%',
                  width: width + '%'
                },
                classes: [sect.type]
              };

              leftPosition += width;
              return ret;
            }), function(obj) {
              return obj;
            });

            //console.log(sectionStyling);

            var availContainerOverlay = element.find('.intelli_view_shift_avail_overlay_container');
            var availSectionTemplate = '<div class="intelli_view_shift_avail_overlay_section"></div>';
            availContainerOverlay.empty();
            availContainerOverlay.append(lodash.map(sectionStyling, function(sect) {
              return $(availSectionTemplate).css(sect.styles).addClass(sect.classes.join(' '));
            }));
            scope.showingAvailability = true;

            $timeout(function() {
              availContainerOverlay.addClass('min_height');
            }, 300);
          }
        };

        scope.getAvail = function() {
          if (scope.obj.$isAssigned()) {
            var eventSuffix = 'getUser';

            if (scope.inThePast) {
              // this event requires that MWPCompositeAvailability has already loaded
              eventSuffix = 'getUserWithAvailability';
            }

            scope.$emit('sa:manageWorkPeriod:' + eventSuffix, {
              userId: scope.obj.user.id,
              fn: function(usr) {
                if (usr && usr.id) {
                  scope.user = usr;

                  drawAvailabilityOverlay();
                } else {
                  $timeout(function() {
                    scope.getAvail();
                  }, 2000);
                }
              }
            });
          }
        };

        var sentTemplateHoursUpdated = function() {
          $rootScope.$broadcast('sa:manageWorkPeriod:templateHoursUpdated', scope.obj);
          //console.log((new Date()).getMilliseconds(), 'sentTemplateHoursUpdated', scope.obj.position_id, scope.obj.range_twix.format());
        };

        if (scope.obj.$isWorkPeriod() && scope.obj.$isAssigned()) {
          $timeout(function() {
            scope.getAvail();
          }, 3000);

          scope.$on('sa:manageWorkPeriod:highlightWorkPeriods', function(event) {
            //console.log('$on ', event.name, 'wp: ', scope.obj.id);
            var highlights = MWPHighlightService.getCurrentHighlight();

            if (highlights && lodash.includes(highlights.workPeriodIds, scope.obj.id)) {
              element.addClass('highlighted');
              $timeout(function() {
                element.removeClass('highlighted');
              }, 5000);
            }
          });

        } else {
          if (scope.obj.$isShift()) {
            sentTemplateHoursUpdated();
          }
          drawIntelliViewShiftHover(scope.obj.range_twix, scope.obj.$isShift(), false);
        }

        if (scope.obj.$isShift()) {
          scope.$on('sa:manageWorkPeriod:editShiftStarted', function(event, shiftId) {
            //console.log('sa:manageWorkPeriod:editShiftStarted: ', shiftId, scope.obj.id);
            if (shiftId !== scope.obj.id) {
              // if
              if (scope.showEditUI) {
                scope.toggleEditable();
              }
              drawIntelliViewShiftHover(scope.obj.editingTwix ? scope.obj.editingTwix : scope.obj.range_twix ,true, scope.obj._dismissed);
              drawIntelliViewShiftEditable(scope.obj.editingTwix ? scope.obj.editingTwix : scope.obj.range_twix, true, false, hasTimeBeenEdited());
            }
          });
        }

        scope.allowedToEdit = function() {
          return scope.obj.$isShift() || (!scope.obj.$isPublished() && !scope.inThePast);
        };


        scope.$on('$destroy', function() {
          lodash.invoke(disposableSubscriptions, 'dispose');
          interact(element[0]).unset();
        });
      }
    };
  });
